import ConfigProvider from 'antd/lib/config-provider'
// import { DisabledContextProvider } from './DisabledContext'
// import type { SizeType } from './SizeContext'
// import SizeContext, { SizeContextProvider } from './SizeContext'

import 'antd/lib/config-provider/style'

export * from 'antd/lib/config-provider'

export * from 'antd/lib/config-provider/context'

export default ConfigProvider
